/**
 * Scheuch Process Designer
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { SeuApiRevisionDto } from '../model/revisionDto';
// @ts-ignore
import { SeuApiSaveRevisionDto } from '../model/saveRevisionDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { SeuApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface CreateRevisionRequestParams {
  /** ID of the offer */
  offerId: string;
  seuApiSaveRevisionDto: SeuApiSaveRevisionDto;
}

export interface DeleteRevisionRequestParams {
  offerId: string;
  revisionId: string;
}

export interface GetRevisionsOfOfferRequestParams {
  /** ID of the offer */
  offerId: string;
}

export interface RestoreRevisionRequestParams {
  /** ID of the offer */
  offerId: string;
  /** The revisions id */
  revisionId: string;
}

@Injectable({
  providedIn: 'root',
})
export class RevisionsApiService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: SeuApiConfiguration
  ) {
    super(basePath, configuration);
  }

  /**
   * Create a revision of the current state of an offer.
   * @endpoint post /offers/{offerId}/revisions
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createRevision(
    requestParameters: CreateRevisionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeuApiRevisionDto>;
  public createRevision(
    requestParameters: CreateRevisionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeuApiRevisionDto>>;
  public createRevision(
    requestParameters: CreateRevisionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeuApiRevisionDto>>;
  public createRevision(
    requestParameters: CreateRevisionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling createRevision.'
      );
    }
    const seuApiSaveRevisionDto = requestParameters?.seuApiSaveRevisionDto;
    if (seuApiSaveRevisionDto === null || seuApiSaveRevisionDto === undefined) {
      throw new Error(
        'Required parameter seuApiSaveRevisionDto was null or undefined when calling createRevision.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/revisions`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SeuApiRevisionDto>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seuApiSaveRevisionDto,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Delete a given revision
   * This endpoint is for the Scheuch team and should not be used in FE. To use this endpoint the user has to have either a ...@scheuch.com or ...@netural.com email ending.
   * @endpoint delete /offers/{offerId}/revisions/{revisionId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteRevision(
    requestParameters: DeleteRevisionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public deleteRevision(
    requestParameters: DeleteRevisionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public deleteRevision(
    requestParameters: DeleteRevisionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public deleteRevision(
    requestParameters: DeleteRevisionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling deleteRevision.'
      );
    }
    const revisionId = requestParameters?.revisionId;
    if (revisionId === null || revisionId === undefined) {
      throw new Error(
        'Required parameter revisionId was null or undefined when calling deleteRevision.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/revisions/${this.configuration.encodeParam({ name: 'revisionId', value: revisionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>(
      'delete',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get all revisions of an offer
   * @endpoint get /offers/{offerId}/revisions
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRevisionsOfOffer(
    requestParameters: GetRevisionsOfOfferRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SeuApiRevisionDto>>;
  public getRevisionsOfOffer(
    requestParameters: GetRevisionsOfOfferRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SeuApiRevisionDto>>>;
  public getRevisionsOfOffer(
    requestParameters: GetRevisionsOfOfferRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SeuApiRevisionDto>>>;
  public getRevisionsOfOffer(
    requestParameters: GetRevisionsOfOfferRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling getRevisionsOfOffer.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/revisions`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<SeuApiRevisionDto>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Restore the state of a given revision into their original offer
   * @endpoint put /offers/{offerId}/revisions/{revisionId}/restore
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public restoreRevision(
    requestParameters: RestoreRevisionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public restoreRevision(
    requestParameters: RestoreRevisionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public restoreRevision(
    requestParameters: RestoreRevisionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public restoreRevision(
    requestParameters: RestoreRevisionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const offerId = requestParameters?.offerId;
    if (offerId === null || offerId === undefined) {
      throw new Error(
        'Required parameter offerId was null or undefined when calling restoreRevision.'
      );
    }
    const revisionId = requestParameters?.revisionId;
    if (revisionId === null || revisionId === undefined) {
      throw new Error(
        'Required parameter revisionId was null or undefined when calling restoreRevision.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer '
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/offers/${this.configuration.encodeParam({ name: 'offerId', value: offerId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/revisions/${this.configuration.encodeParam({ name: 'revisionId', value: revisionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/restore`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined
        ? { transferCache: localVarTransferCache }
        : {}),
      reportProgress: reportProgress,
    });
  }
}
